<div class="mention-textarea-container">
  <div [id]="innerId" [class]="'mention-textarea-quill ' + innerClass" [style]="innerStyle"></div>
</div>
